import ExcelJS from 'exceljs';
import dateFormat from "dateformat";

export async function exportExcelWithMergedHeaders(items, filename) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Relatório');
  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));

  // 🔹 Cabeçalhos principais
  worksheet.mergeCells('A1:H1');
  worksheet.getCell('A1').value = 'DIAS';
  worksheet.getCell('A2').value = 'TIPO';
  worksheet.getCell('B2').value = 'NOME';
  worksheet.getCell('C2').value = 'UNIDADE';
  worksheet.getCell('D2').value = 'Qtd Total';
  worksheet.getCell('E2').value = 'Total';
  worksheet.getCell('F2').value = 'Custo Total';
  worksheet.getCell('G2').value = 'CMV (%)';
  worksheet.getCell('H2').value = 'CMV';
  worksheet.getCell('BR2').value = 'ÚLTIMA ALTERAÇÃO';

  ['A1', 'B1', 'A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2', 'H2', 'BR2'].forEach(cell => {
    worksheet.getCell(cell).alignment = { horizontal: 'center', vertical: 'middle' };
  });

  let colIndex = 9;
  days.forEach(day => {
    worksheet.mergeCells(1, colIndex, 1, colIndex + 1);
    worksheet.getCell(1, colIndex).value = day;
    worksheet.getCell(2, colIndex).value = 'Qtd';
    worksheet.getCell(2, colIndex + 1).value = 'CMV';

    worksheet.getCell(1, colIndex).alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getCell(2, colIndex).alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getCell(2, colIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };

    colIndex += 2;
  });

  items.forEach((item, rowIdx) => {
    const excelRow = rowIdx + 3;

    worksheet.getCell(excelRow, 1).value = item.type;
    worksheet.getCell(excelRow, 2).value = item.name;
    worksheet.getCell(excelRow, 3).value = item.unit;
    worksheet.getCell(excelRow, 4).value = item.totalQtd;

    worksheet.getCell(excelRow, 5).value = item.total / 100;
    worksheet.getCell(excelRow, 5).numFmt = '"R$"#,##0.00';

    worksheet.getCell(excelRow, 6).value = item.totalCost / 100;
    worksheet.getCell(excelRow, 6).numFmt = '"R$"#,##0.00';

    // ✅ CMV (%) – custo / total
    const cmvPercent = item.total > 0 ? item.totalCost / item.total : 0;
    worksheet.getCell(excelRow, 7).value = cmvPercent;
    worksheet.getCell(excelRow, 7).numFmt = '0.00%';

    worksheet.getCell(excelRow, 8).value = (item.totalCost / item.totalQtd) / 100;
    worksheet.getCell(excelRow, 8).numFmt = '"R$"#,##0.00';

    colIndex = 9;
    days.forEach(day => {
      const qtd = item?.days?.[day]?.totalQuantity ?? 0;
      const valor = item?.days?.[day]?.totalCoust ?? 0;

      worksheet.getCell(excelRow, colIndex).value = qtd;
      worksheet.getCell(excelRow, colIndex + 1).value = valor / 100;
      worksheet.getCell(excelRow, colIndex + 1).numFmt = '"R$"#,##0.00';

      colIndex += 2;
    });

    const { lastInsumeModified } = item;
    worksheet.getCell(excelRow, colIndex).value = lastInsumeModified
      ? dateFormat(
        new Date(
          lastInsumeModified._seconds * 1000 +
          Math.floor(lastInsumeModified._nanoseconds / 1e6)
        ),
        'dd/mm/yyyy HH:MM'
      )
      : '';
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
